import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-6 py-16 text-center" data-testid="not-found-container">
      <div className="max-w-md space-y-8" role="main" aria-label="Page not found" data-testid="not-found-page">
        {/* 404 Visual */}
        <div className="space-y-4">
          <div className="inline-flex items-center justify-center size-24 rounded-full bg-primary/20 mb-4">
            <span className="material-symbols-outlined text-5xl text-primary">explore_off</span>
          </div>
          <h1 className="text-6xl font-display font-bold text-text-main dark:text-white">
            404
          </h1>
          <h2 className="text-2xl font-display font-bold text-text-main dark:text-white">
            Page Not Found
          </h2>
          <p className="text-gray-500 dark:text-text-muted">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="btn btn-primary px-6 py-3 font-bold"
          >
            <span className="material-symbols-outlined text-xl mr-2">home</span>
            Go to Home
          </Link>

          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary px-6 py-3 font-bold"
          >
            <span className="material-symbols-outlined text-xl mr-2">arrow_back</span>
            Go Back
          </button>
        </div>

        {/* Quick Links */}
        <div className="bg-surface-light dark:bg-surface-card rounded-lg p-6 border border-black/5 dark:border-white/10">
          <h3 className="text-sm font-bold text-text-main dark:text-white mb-4">
            Quick Links
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/discover"
              className="flex items-center gap-2 text-sm text-gray-500 dark:text-text-muted hover:text-primary transition-colors"
            >
              <span className="material-symbols-outlined text-lg">explore</span>
              Discover Courses
            </Link>
            <Link
              to="/dashboard"
              className="flex items-center gap-2 text-sm text-gray-500 dark:text-text-muted hover:text-primary transition-colors"
            >
              <span className="material-symbols-outlined text-lg">dashboard</span>
              Dashboard
            </Link>
            <Link
              to="/profile"
              className="flex items-center gap-2 text-sm text-gray-500 dark:text-text-muted hover:text-primary transition-colors"
            >
              <span className="material-symbols-outlined text-lg">person</span>
              Profile
            </Link>
          </div>
        </div>

        {/* Error Code */}
        <p className="text-xs text-gray-500 dark:text-text-muted">
          Error Code: 404
        </p>
      </div>
    </div>
  )
}

export default NotFoundPage
